import {attr, controller} from '@github/catalyst'
import {GetRepoElement} from './get-repo-element'
import {observe} from '@github-ui/selector-observer'

@controller('repo-codespaces-count')
class RepoCodespacesCountElement extends HTMLElement {
  static attrPrefix = ''
  @attr codespacesCount = 0

  connectedCallback() {
    observe('get-repo', {
      constructor: GetRepoElement,
      add: el => {
        this.handleGetRepoElement(el)
      },
    })
  }

  handleGetRepoElement(getRepoElement: GetRepoElement) {
    if (!getRepoElement.openOrCreateInCodespace) {
      return
    }
    if (this.codespacesCount === 0) {
      getRepoElement.showOpenOrCreateInCodespace()
    } else {
      getRepoElement.removeOpenOrCreateInCodespace()
    }
  }
}
